"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Enum used to control other value placement
 *
 * @author hayk.martirosyan
 *
 */
var OtherType;
(function (OtherType) {
    OtherType[OtherType["NONE"] = 0] = "NONE";
    OtherType[OtherType["BEFORE"] = 1] = "BEFORE";
    OtherType[OtherType["AFTER"] = 2] = "AFTER";
})(OtherType = exports.OtherType || (exports.OtherType = {}));
//# sourceMappingURL=other-type.js.map